import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject, of } from 'rxjs';
import { catchError, map, shareReplay, startWith } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss']
})
export class PublicLayoutComponent implements OnDestroy {
  @ViewChild(MatSidenav) sidenav?: MatSidenav;
  readonly year = new Date().getFullYear();
  isHandset = false;
  private readonly destroy$ = new Subject<void>();

  readonly isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map(result => result.matches),
    startWith(false),
    catchError(() => of(false)),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(private readonly breakpointObserver: BreakpointObserver) {
    this.isHandset$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isHandset => {
        this.isHandset = isHandset;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeIfHandset(isHandset: boolean) {
    if (isHandset) this.sidenav?.close();
  }
}
